import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { App, NavController, NavParams } from 'ionic-angular';
import { UserProvider } from '../../providers/user/user';
import { LoginPage } from '../login/login/login';
import { SessionProvider } from '../../providers/session/session';
import { TabsPage } from '../tabs/tabs';
import { IdRegistrationPage } from '../login/id-registration/id-registration';
import { AppDetectorProvider } from '../../providers/detector/detector';
import { EventSearchPage } from '../event/main/event-search/event-search';


/**
 * Generated class for the WelcomePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-welcome',
  templateUrl: 'welcome.html',
})
export class WelcomePage {

  constructor(
    public app: App,
private appDetector: AppDetectorProvider,
    public userService: UserProvider,
    public navCtrl: NavController,
    public navParams: NavParams,
    public translate: TranslateService,
    private sessionService: SessionProvider,
    private detectorProvider: AppDetectorProvider
  ) {
  }

  ionViewDidLoad() {
  }

  skip() {
    let page = this.appDetector.isEventsApp() ? EventSearchPage : TabsPage;
    this.navCtrl.setRoot(page);
  }

  public isLoged(): boolean {
    return this.sessionService.isLoged;
  }

  showLogin() {
    if (this.detectorProvider.isHellaApp()) {
      this.sessionService.getToken(false, false).then(token => {
        this.app.getRootNav().push(IdRegistrationPage);
      });
    } else {
      this.app.getRootNav().push(LoginPage)
    }
  }

}



// WEBPACK FOOTER //
// /src/pages/welcome/welcome.ts